export enum UpsaleRiskIdEnum {
  AcAsoStalaSu = 'ac_aso_stala_su',
  AcGuarantedSum = 'acGuarantedSum',
}
